'use strict';
const calcMaxWidth = require('../util/calc-max-width'),
	formattedNodeTitle = require('../content/formatted-node-title'),
	URLHelper = require('../util/url-helper'),
	NodeMetrics = require('./node-metrics'),
	emptyLabels = Object.freeze({});
module.exports = function NodeViewModel(themeProvider, activeContentProvider, textSizer, optional) {
	/* responsible for working out the internal positions of
	 * elements in the node on display, such as where the image and text are
	 * relative to the top-left corner of the node.
	 *
	 * does not know anything about where a node is relative to other nodes in the map,
	 * that is the responsibility of the layout object
	 */

	let labelGenerator, labels = emptyLabels, nodeViewCache = {};
	const resourceTranslator = (optional && optional.resourceTranslator),
		shouldSkipNodeLabel = (idea) => {
			const nodeTheme = idea && idea.id && themeProvider.getNodeTheme(idea.id);
			return !!(nodeTheme && nodeTheme.unlabelled);
		},
		dropCache = function () {
			nodeViewCache = {};
			if (labelGenerator) {
				labels = Object.freeze(Object.assign({}, labelGenerator(activeContentProvider.getActiveContent(), shouldSkipNodeLabel)));
			} else {
				labels = emptyLabels;
			}
		},
		getIcon = (attr) => {
			if (!attr || !attr.icon) {
				return false;
			}
			if (!resourceTranslator || !attr.icon.url) {
				return attr.icon;
			}
			return Object.assign({}, attr.icon, {url: resourceTranslator(attr.icon.url)});
		},
		getStickers = attr => (attr && Array.isArray(attr.stickers) &&  attr.stickers) || [],
		buildNodeViewForNodeThemeAndAttr = (nodeTheme, effectiveStyles, attr, title, label) => {
			const nodeMetrics = new NodeMetrics(),
				attachment = attr && attr.attachment,
				formattedTitle = formattedNodeTitle(title),
				icon = getIcon(attr),
				nodeHyperlink = URLHelper.getLink(title),
				shouldSizeText = formattedTitle || !icon,
				textWrappingWidth = calcMaxWidth(attr, nodeTheme),
				stickers = getStickers(attr),
				note = attr && attr.note,
				countStandardDecorations = function () {
					const countInteractiveDecorations = !(optional && optional.passive),
						interactive = [note, attachment, nodeHyperlink].filter(decoration => !!decoration),
						interactiveCount = countInteractiveDecorations ? interactive.length : 0;
					return interactiveCount + stickers.length;
				},
				isGroup = attr && attr.group;
			nodeMetrics.requireNodeStyleWidth(attr && attr.style && attr.style.width);
			nodeMetrics.requireBorder(nodeTheme.lineWidth);
			nodeMetrics.requireMargin(nodeTheme.margin);
			nodeMetrics.requireCornerRadius(nodeTheme.cornerRadius);

			nodeMetrics.requireIconBox(icon);

			if (shouldSizeText) {
				nodeMetrics.requireTextBox(textSizer(formattedTitle || 'M', textWrappingWidth, nodeTheme.font));
			}

			nodeMetrics.requireDecorations(
				nodeTheme.decorations,
				label && textSizer(label, 0, nodeTheme.decorations.label.font),
				countStandardDecorations()
			);

			return {
				metrics: nodeMetrics.calculate(),
				title: isGroup ? '' : formattedTitle.trim(),
				fullTitle: title,
				label: label,
				hyperlink: nodeHyperlink,
				note: note,
				attachment: attachment,
				icon: icon,
				theme: nodeTheme,
				isGroup: isGroup,
				effectiveStyles: effectiveStyles,
				stickers: stickers
			};
		},
		createNodeViewForIdea = function (idea) {
			const nodeTheme = themeProvider.getNodeTheme(idea.id),
				label = labels[idea.id],
				result = buildNodeViewForNodeThemeAndAttr(nodeTheme, nodeTheme.effectiveStyles, idea.attr, idea.title, label);
			result.nodeId = idea.id;
			return result;
		},
		setLabelGenerator = function (newLabelGenerator) {
			labelGenerator = newLabelGenerator;
			dropCache();
		},
		getLabelMap = function () {
			return labels;
		},
		getNodeViewForIdea = function (idea) {
			if (!nodeViewCache[idea.id]) {
				nodeViewCache[idea.id] = createNodeViewForIdea(idea);
			}
			return nodeViewCache[idea.id];
		},
		getNodeViewForIdeaId = function (ideaId) {
			if (nodeViewCache[ideaId]) {
				return nodeViewCache[ideaId];
			}
			const aggregate = activeContentProvider.getActiveContent(),
				idea = aggregate.findSubIdeaById(ideaId);
			if (!idea) {
				throw new Error('invalid args');
			}
			return getNodeViewForIdea(idea);
		};
	activeContentProvider.addListener(() => {
		dropCache();
	});

	Object.freeze(Object.assign(this, {
		setLabelGenerator, getLabelMap, buildNodeViewForNodeThemeAndAttr, getNodeViewForIdea, getNodeViewForIdeaId, dropCache
	}));

};
